import React from "react";
import './Loader.scss'
import loader from "assets/images/Rapidonkey_Loader.gif";

export default () => (
    <div className={'container'}>
        <img className='loader' src={loader}/>
    </div>
)